// Actions
const ACTION_TYPES = {
  SET_ALL_MARKETPLACE_ASSETS: "web-app-magmic-core/user/SET_ALL_MARKETPLACE_ASSETS", // sufficient until we start using pagination
}

export const setAllMarketplaceAssets = (allAssets) => ({
  type: ACTION_TYPES.SET_ALL_MARKETPLACE_ASSETS,
  allAssets: allAssets
});

const initialState = {assets:[]};

// Reducers
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTION_TYPES.SET_ALL_MARKETPLACE_ASSETS:
      return {
        ...state,
        assets: action.allAssets // may actually be sufficient for pagination (merges with '...state')
      };
    default:
      return state; // returned during app initialization
  }
}
